module.exports = __webpack_public_path__ + "img/classe3.84a718e6.jpg";